import React from "react";
import { harmonyRingEnabled } from "src/config/config";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import {
  ForgetPassword,
  Programmes,
  ProgrammesDetail,
  Calender,
  HelpingVideos,
  HelpingVideoDetail,
} from "./pages/index";
import EditProfile from "./pages/Profile/EditProfile";
import Login from "./pages/Login";
import DashboardApp from "./pages/DashboardApp";

import LoginByAdmin from "./pages/LoginByAdmin";
import MagicLogin from "./pages/MagicLogin";
import UserForms from "./pages/UserInformation/UserForms";
import UserInformationform from "./pages/UserInformation/UserInformationform";
import DetailsFormInformation from "./pages/UserInformation/DetailsFormInformation";
import ProgramCalender from "./pages/Programmes/ProgramCalender";
import Feed from "./pages/CommunityFeeds/Feed";
import GroupsFeedsDetail from "./pages/CommunityFeeds/GroupsFeedsDetail";
import MyPosts from "./pages/CommunityFeeds/MyPosts";
import FeedDetailPage from "./pages/CommunityFeeds/FeedDetailPage";
import RecentPointsTable from "./components/_dashboard/app/RecentPointsTable";
import HelpingVideosCategory from "./pages/HelpingVideos/HelpingVideosCategory";
import Chat from "./pages/Chat/Chat";
import FriendList from "./pages/Chat/FriendList";
import RedirectPage from "./pages/HelpingVideos/RedirectPage";
// Legacy table.css used to load through CustomMUITable (removed; Support Tickets was its last user). Kept here, at the
// same point in the import order, so the CSS order (and every older screen's look) stays the same.
import "./assets/css/table.css";
import SupportTicket from "./pages/SupportTickets/SupportTicket";
import SupportTicketDetail from "./pages/SupportTickets/SupportTicketDetail";
import ShoppingList from "./pages/ShoppingList";
import WeightTracker from "./pages/WeightTracker/WeightTracker";
import VidoeLibrary from "./pages/Video/VidoeLibrary";
import VidoeLibraryDetail from "./pages/Video/VidoeLibraryDetail";
import MemberChartInfo from "./pages/Programmes/MemberChartInfo";
import WorkoutEditFullPage from "./pages/Programmes/WorkoutEditFullPage";
import MemberTrackersList from "./pages/Trackers/MemberTrackersList";
import MemberTrackerDetail from "./pages/Trackers/MemberTrackerDetail";
import MemberTrackerSubmitPage from "./pages/Trackers/MemberTrackerSubmitPage";
import GuestDashboard from "./pages/Trackers/GuestDashboard";
import VerifyProgressReportLive from "./pages/Trackers/VerifyProgressReportLive";
import { useContentSetting } from "./Hooks/ContentContext/ContentSettingState";
import { isGuestMember } from "./utils/guestMember";

// Design Elements spec page: development only. In a production build this is null and the page is not bundled.
const DesignElementsPage =
  process.env.NODE_ENV === "development"
    ? React.lazy(() => import("./design-system/DesignElementsPage"))
    : null;

const Authentication = () => {
  if (localStorage.getItem("token")) {
    return <Navigate to="/dashboard"> </Navigate>;
  } else {
    <Navigate to="/login"> </Navigate>;
  }
};

/** Journey guests (magic-link login) get a lightweight journeys dashboard. */
const DashboardHome = () => {
  const { userInfo } = useContentSetting();
  return isGuestMember(userInfo) ? <GuestDashboard /> : <DashboardApp />;
};

export default function Router() {
  return (
    <Routes>
      <Route
        path="/workout-edit/:id/:CalId/:workoutId"
        element={<WorkoutEditFullPage />}
      />
      <Route path="/login-by-admin/:token" element={<LoginByAdmin />} />
      <Route path="/magic-login/:token" element={<MagicLogin />} />
      {/* Temporary live check — not in menus; works logged-in or out */}
      <Route
        path="/verify-progress-report"
        element={<VerifyProgressReportLive />}
      />
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/dashboard" element={<DashboardHome />} />
        <Route path="/dashboard-coins-info" element={<RecentPointsTable />} />
        <Route path="/dashboard/shopping-list" element={<ShoppingList />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/chat/friend-list" element={<FriendList />} />
        <Route path="/forms" element={<UserForms />} />
        <Route
          path="/forms-submition/:slug"
          element={<UserInformationform />}
        />
        <Route
          path="/forms-Details/:slug"
          element={<DetailsFormInformation />}
        />
        <Route
          path="/forms-Details/:slug/:user_id"
          element={<DetailsFormInformation />}
        />
        <Route path="/programmes" element={<Programmes />} />
        <Route path="/programmes/:slug" element={<ProgrammesDetail />} />
        {harmonyRingEnabled && (
          <Route
            path="/programmes/calendar/:slug/:program_id"
            element={<MemberChartInfo />}
          />
        )}
        <Route
          path="/programmes/calendar/:slug"
          element={<ProgramCalender />}
        />
        <Route path="/videos-library" element={<VidoeLibrary />} />
        <Route
          path="/videos-library/:library_id"
          element={<VidoeLibraryDetail />}
        />
        <Route path="/weight-tracker" element={<WeightTracker />} />
        <Route path="/trackers" element={<MemberTrackersList />} />
        <Route
          path="/trackers/:id/submit"
          element={<MemberTrackerSubmitPage />}
        />
        <Route path="/trackers/:id" element={<MemberTrackerDetail />} />
        <Route path="/calendar" element={<Calender />} />
        <Route path="/community-area" element={<Feed />} />
        <Route path="/my-posts" element={<MyPosts />} />
        <Route
          path="/community-area-post-detail/:id"
          element={<FeedDetailPage />}
        />
        <Route path="/group-feed/:id" element={<GroupsFeedsDetail />} />
        <Route
          path="/helping_videos_category"
          element={<HelpingVideosCategory />}
        />
        <Route
          path="/helping_videos_category/helping-videos/:id"
          element={<HelpingVideos />}
        />
        <Route
          path="/helping_videos_category/:id/helping-videos/:slug"
          element={<HelpingVideoDetail />}
        />
        <Route path="/redirect-page" element={<RedirectPage />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/support-ticket/:id" element={<SupportTicketDetail />} />
        <Route path="/edit-profile" element={<EditProfile />} />
        {DesignElementsPage && (
          <Route
            path="/design-elements"
            element={
              <React.Suspense fallback={null}>
                <DesignElementsPage />
              </React.Suspense>
            }
          />
        )}
        <Route path="*" element={<Authentication />} />
      </Route>
      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget_password" element={<ForgetPassword />} />
        <Route path="*" element={<Authentication />} />
      </Route>
    </Routes>
  );
}
